module.exports = __webpack_public_path__ + "static/img/D.0761154.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/D.png
// module id = UbNl
// module chunks = 88